export enum CustomerPartner {
    WW = 1,
    EXTENSO = 9
}
